import {configureStore, isRejectedWithValue} from "@reduxjs/toolkit"
import api from "../api/base-api"
import root from "../reducers/index"
import {getEnvironment} from "../../constants";
import {parseFormDataTextToJsonString} from "./constants";
import * as Sentry from "@sentry/react";
import {types} from "../reducers/commonData";
import {alertsBridge} from "./alertsBridge";

Sentry.init({
    dsn: 'https://c3ae6387a7cd795db2c2c7852f516811@ita-sentry.belka-games.com/38',
    environment: getEnvironment()
});

window.onerror = function (message, source, lineno, colno, error) {
    console.error('Global onerror caught:', message, source, lineno, colno, error);
    Sentry.captureException(error || new Error(message));
};

window.onunhandledrejection = function (event) {
    console.error('Unhandled promise rejection:', event.reason);
    //Sentry.captureException(event.reason || new Error('Unhandled rejection'));
};

function buildAlertText(action) {
    const endpoint = action.meta?.arg?.endpointName ?? 'request'
    const status = action.payload?.status ?? 'error'
    const data = action.payload?.data
    let details = ''
    if (data != null) {
        if (typeof data === 'string') {
            details = data
        } else if (data.message) {
            details = data.message
        } else if (data.error) {
            details = typeof data.error === 'string' ? data.error : JSON.stringify(data.error)
        } else {
            details = JSON.stringify(data)
        }
    }
    if (details.length > 300) details = details.slice(0, 300) + '…'
    return details ? `${endpoint} [${status}]: ${details}` : `${endpoint} [${status}]`
}

const myLoggingMiddleware = storeAPI => next => action => {
    if (isRejectedWithValue(action)) {
        const jsonError = JSON.stringify(action.payload.data);

        const severity = (action.payload.status >= 400 && action.payload.status <= 405) ?  Sentry.Severity.Info : Sentry.Severity.Error

        alertsBridge.addAlert({text: buildAlertText(action), type: 'error'})

        if (action.meta.baseQueryMeta?.request?.body != null) {
            action.meta.baseQueryMeta.request.body.getReader().read().then(response => {
                const jsonRequest = JSON.stringify({body: parseFormDataTextToJsonString(new TextDecoder().decode(response.value))});
                Sentry.captureMessage(
                    `Ошибка при отправке запроса\n${jsonError}\n${jsonRequest}`,
                    severity
                )
            });
        } else {
            Sentry.captureMessage(
                `Ошибка при отправке запроса ${jsonError}`,
                severity
            )
        }
    }
    return next(action)
}

export function clearIsMassCharge(dispatch) {
    dispatch({
        type: types.SET_MASS_CHARGE,
        payload: {isMassCharge: false},
    });
}


export const store = configureStore({
    reducer: {
        [api.reducerPath]: api.reducer,
        data: root,

    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(api.middleware).concat(myLoggingMiddleware)
})
